/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
*                _
*  _            | | _
* | |         _ | || |
* | |__   _  | || || |__
* | '_ \ | | | || || '_ \
* | (_) || |_| || || (_) |
*  \___/  \___/ |_| \___/
*
*
*/

/**
 * Helper function that adds a comment in the selected block.
 *
 * @param editor The current editor instance
 * @private
 */
export function addComment(editor) {
  const { t } = editor;
  const block = editor.model.document.selection.getSelectedElement();
  let id = '';
  let selectedText = '';
  let nodeType = null;

  if (block) {
    id = block._attrs.get('bulb-block-id');
    nodeType = 'FIGURE';
  } else {
    const { selection } = editor.model.document;
    const selectedContentNodes = editor.model.getSelectedContent(selection)._children._nodes;

    const range = selection.getFirstRange();

    // This will check if multiple list items are selected or not.
    if (selectedContentNodes.length > 1) {
      id = selectedContentNodes[0].getAttribute('bulb-id');
      for (const node of selectedContentNodes) {
        selectedText = selectedText.concat(' ', node._children.getNode(0)._data);
      }
    } else {
      for (const item of range.getItems()) {
        id = item.textNode?.parent?.getAttribute('bulb-id');
        selectedText = item.data;
      }
    }
  }

  const openInlineCommentBox = new CustomEvent('openInlineCommentBox', {
    detail: {
      id,
      text: selectedText,
      nodeType,
    },
  });
  window.dispatchEvent(openInlineCommentBox);
}
